import {ArticleSearchResultDto} from "../../core/models/interfaces/article-search-result-dto.interface";
import {ArticleDetails} from "../../core/models/interfaces/article-details.interface";

export const mapArticleDetailsToSearchResult = (dto: ArticleDetails): ArticleSearchResultDto => {
    return {
        isUniversal: dto.isUniversal,
        isPostoperative: dto.isPostoperative,
        edited: dto.editedAt,
        title: dto.title,
        tags: dto.tags,
        isVisible: dto.isVisible,
        id: dto.id,
    }
}
